import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.min.js';
import './App.css';
import CateringMenu from './components/LP/catering'

function App() {
  
  return (
    <div className="App h-100">
      <CateringMenu/>
    </div>
  );
}

export default App;